import React from 'react';

function CategoryDefault({ ...rest }) {
  return (
    <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
      <g clipPath="url(#clip0_2_9487)">
        <path fillRule="evenodd" clipRule="evenodd" d="M13 26C20.1797 26 26 20.1797 26 13C26 5.8203 20.1797 0 13 0C5.8203 0 0 5.8203 0 13C0 20.1797 5.8203 26 13 26ZM13.5327 5.5C13.1478 4.83333 12.1855 4.83333 11.8006 5.5L8.91386 10.5C8.52896 11.1667 9.01009 12 9.77989 12H15.5534C16.3232 12 16.8043 11.1667 16.4194 10.5L13.5327 5.5ZM22.0001 16.6667C22.0001 18.8758 20.2092 20.6667 18.0001 20.6667C15.791 20.6667 14.0001 18.8758 14.0001 16.6667C14.0001 14.4575 15.791 12.6667 18.0001 12.6667C20.2092 12.6667 22.0001 14.4575 22.0001 16.6667ZM6.66663 13.3333C5.56206 13.3333 4.66663 14.2288 4.66663 15.3333V18.6667C4.66663 19.7712 5.56206 20.6667 6.66663 20.6667H9.99996C11.1045 20.6667 12 19.7712 12 18.6667V15.3333C12 14.2288 11.1045 13.3333 9.99996 13.3333H6.66663Z" />
      </g>
      <defs>
        <clipPath id="clip0_2_9487">
          <rect width="26" height="26" fill="white" />
        </clipPath>
      </defs>
    </svg>

  );
}

export default CategoryDefault;
